import dayjs from 'dayjs';

import { MDText } from 'i18n-react';

import { Enquiry } from 'Utilities/vehicles/@types';

import { LatestPostSaleOffer, PaymentStatuses, PostSaleOfferApprovals } from '../../../payments/Payments.types';
import { DAYS_TO_EXPIRE_ENQUIRY } from '../../../vehicleProfiling/VehicleProfiling.constants';
import AccountTexts from '../../Pages/AccountPage/AccountPage.texts.json';

const AccountT = new MDText(AccountTexts);

const getPaymentStatusCta = (status: string): React.ReactNode => {
  switch (status) {
  case 'done':
  case 'failed':
    return AccountT.translate('paymentsCTA.viewPaymentDetails');
  case 'pending':
    return AccountT.translate('paymentsCTA.viewPaymentStatus');
  default:
    return '';
  }
};

const getPostSaleOfferCta = (offerData: LatestPostSaleOffer): React.ReactNode => {
  const { approvals, state } = offerData;

  if (state !== 'approved' && state !== 'pending') {
    return '';
  }

  const isApprovedBySeller = approvals.some(
    (approval: PostSaleOfferApprovals) => approval.userType === 'seller',
  );

  if (!isApprovedBySeller) {
    return AccountT.translate('paymentsCTA.approvePayment');
  }

  return AccountT.translate('paymentsCTA.viewPaymentStatus');
};

export const getPaymentCta = (
  paymentsStatuses?: PaymentStatuses | null,
  latestPostSaleOfferData?: LatestPostSaleOffer | null,
): string => {
  if (paymentsStatuses) {
    return `${getPaymentStatusCta(paymentsStatuses.status)}`;
  }

  if (latestPostSaleOfferData?.type === 'counter_offer') {
    return `${getPostSaleOfferCta(latestPostSaleOfferData)}`;
  }

  return '';
};

export const checkEnquiryActive = (enquiry?: Enquiry) => {
  const enquiryExpiredDate = dayjs(enquiry?.createdAt).add(DAYS_TO_EXPIRE_ENQUIRY, 'day');
  return enquiry ? dayjs(Date.now()).isBefore(enquiryExpiredDate) : false;
};
